import { PromoCodeActionMenu } from "./PromoCodeActionMenu";

export const promoCodeColumns = (actionHandlers = {}, visibility, teamCurrencySymbol) => {
  const baseColumns = [
    {
      field: "code",
      headerName: "Code",
      flex: 1
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1
    },
  ];

  // Conditionally add company column
  const companyColumn = {
    field: "company_name",
    headerName: "Company",
    flex: 1
  };

  const remainingColumns = [
    {
      field: "discount_type",
      headerName: "Discount Type",
      flex: 1
    },
    {
      field: "discount_value",
      headerName: "Discount",
      flex: 1,
      renderCell: (params) => {
        return params.row.discount_type === "PERCENTAGE"
          ? `${params.row.discount_value}%`
          : `${teamCurrencySymbol}${params.row.discount_value}`;
      },
    },
    {
      field: "valid_to",
      headerName: "Valid Until",
      flex: 1,
      renderCell: (params) => {
        return new Date(params.row.valid_to).toLocaleDateString("en-IN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      },
    },
    {
      field: "usage_limit",
      headerName: "Uses Limit",
      flex: 1
    },
    {
      field: "used_count",
      headerName: "Total Used",
      flex: 1
    },
    {
      field: "is_active",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        return params.row.is_active ? "Active" : "Inactive";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      flex: 1,
      renderCell: (params) => (
        <PromoCodeActionMenu
          id={params.row.id}
          row={params.row}
          onEdit={actionHandlers.onEdit}
          onView={actionHandlers.onView}
          onDelete={actionHandlers.onDelete}
          onStatusChange={actionHandlers.onStatusChange}
        />
      ),
    }
  ];

  // Return columns with or without company column based on data
  return visibility
    ? [...baseColumns, companyColumn, ...remainingColumns]
    : [...baseColumns, ...remainingColumns];
};

export const topPromoCodeColumns = [
  {
    field: "code",
    headerName: "Code",
    flex: 1
  },
  {
    field: "usageCount",
    headerName: "Usage",
    flex: 1
  },
  {
    field: "totalRevenue",
    headerName: "Revenue",
    flex: 1,
    renderCell: (params) => {
      return Number(params.row.totalRevenue).toFixed(2);
    },
  },
  // {
  //   field: "conversion",
  //   headerName: "Conversion %",
  //   flex: 1
  // },
];

export const topPromoCodeConColumns = [
  {
    field: "code",
    headerName: "Code",
    flex: 1
  },
  {
    field: "assignedCount",
    headerName: "Assigned Count",
    flex: 1
  },
  {
    field: "transactions",
    headerName: "Transactions",
    flex: 1
  },
  {
    field: "conversionRate",
    headerName: "Conversion Rate",
    flex: 1
  },

]

export const promoCodeInitialValues = () => ({
  code: "",
  name: "",
  description: "",
  discount_type: "PERCENTAGE",
  discount_type_for: "CHARGING",
  discount_value: "",
  max_discount_value: "",
  min_trx_value: "",
  valid_from: "",
  valid_to: "",
  usage_limit: "",
  is_active: true,
  //  usage_frequency: 1,
});

export const ENUMS = {
  discount_type_for: {
    CHARGING: "CHARGING",
    SIGNUP: "SIGNUP",
  },
  discount_type: {
    PERCENTAGE: "PERCENTAGE",
    FIXED: "FIXED",
  },
}

export const STATS_TYPE = {
  TOTAL_USAGE: "TOTAL_USAGE",
  TOTAL_REVENUE: "TOTAL_REVENUE",
  AVG_DISCOUNT_PERCENT: "AVG_DISCOUNT_PERCENT",
  CONVERSION_RATE_PERCENT: "CONVERSION_RATE_PERCENT"
}

export const STATS_LABELS = {
  TOTAL_USAGE: "Total Usage",
  TOTAL_REVENUE: "Total Revenue",
  AVG_DISCOUNT_PERCENT: "Avg. Discount",
  CONVERSION_RATE_PERCENT: "Conversion Rate",
}

export const STATS_ICONS = {
  TOTAL_USAGE: "eva:people-outline",
  TOTAL_REVENUE: "eva:pricetags-outline",
  AVG_DISCOUNT_PERCENT: "eva:percent-outline",
  CONVERSION_RATE_PERCENT: "eva:trending-up-outline",
}

export const GRAPH_TYPE = {
  USAGE: "USAGE",
  REVENUE: "REVENUE",
  TOP_PERFORMING: "TOP_PERFORMING",
  CONVERSION_RATE: "CONVERSION_RATE",
  STATUS: "STATUS"
}